import { useState } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import { PropertyRow } from '../../../theme/components/PropertyRow'
import { StyledError } from '../../../theme/components/StyledError'
import { useUpdateProjectbetrokkeneDisciplines } from '../../hooks/useUpdateProjectbetrokkeneDisciplines'

import { SelectDisciplines } from './SelectDisciplines'

export { EditDisciplines }

type Props = {
  projectbetrokkene: Projectbetrokkene & { _id: string }
  onClose: () => void
}

/** De api bepaalt of een verwijderde discipline ook echt niet meer in gebruik is */
const EditDisciplines = ({ projectbetrokkene, onClose }: Props) => {
  const { mutate: updateDisciplines, error } =
    useUpdateProjectbetrokkeneDisciplines()

  const [disciplines, setDisciplines] = useState(
    projectbetrokkene.disciplines ?? [],
  )

  const handleSubmit = () =>
    updateDisciplines(
      { id: projectbetrokkene._id, disciplines },
      { onSuccess: onClose },
    )

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Disciplines wijzigen</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <PropertyRow
          label="Netbeheerder"
          value={projectbetrokkene.organisatie}
        />

        <PropertyRow
          label="Gebied"
          value={projectbetrokkene.gebiedscodeLabel}
        />

        <SelectDisciplines
          projectType={projectbetrokkene.projectType}
          value={disciplines}
          onChange={setDisciplines}
        />

        <StyledError error={error} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Sluiten
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={disciplines.length === 0}
        >
          Opslaan
        </Button>
      </DialogActions>
    </Dialog>
  )
}
